import React from 'react';
import PreFormGeneric from '../../../../../common/PreFormGeneric';
import { useLocation } from 'react-router-dom';

const PreFormAuthorizedThirdMobile = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const motiveId = params.get('motiveId');

  return (
    <PreFormGeneric mobile motiveId={motiveId} issueForm={'AuthorizedThird'} />
  );
};

export default PreFormAuthorizedThirdMobile;
